import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { installGlobalErrorHandlers } from "./lib/reportError.js";
import { MaintenanceScreen } from "./components/MaintenanceScreen.js";
import { healthChecker, watchApiStatus } from "./lib/apiStatus.js";
import { getApiBaseUrl } from "./apiClient.js";
import "./styles.css";
import { getLanguage } from "./lib/i18n/store.js";
import { loadDictionary } from "./lib/i18n/dictionaries.js";

// Catch uncaught errors / unhandled rejections before React even mounts.
installGlobalErrorHandlers();

// A redeploying API shows one maintenance screen instead of broken pages.
watchApiStatus({ checkHealth: healthChecker(`${getApiBaseUrl()}/api/health`) });
// Fetch its picture now: when the API goes down there is no time to wait for it.
if (typeof Image !== "undefined") new Image().src = "/assets/maintenance.webp";

// A saved non-English locale loads before the first render, avoiding a flash
// of English; index.html has already started its download (see
// lib/i18n/dictionaryPreload.ts). Other locale dictionaries are never
// downloaded on startup.
void loadDictionary(getLanguage()).catch(() => undefined).then(() => {
  createRoot(document.getElementById("root") as HTMLElement).render(
    <StrictMode>
      <ErrorBoundary>
        <App />
        <MaintenanceScreen />
      </ErrorBoundary>
    </StrictMode>
  );
});
